import { REGEX } from '@/constants/regex';
import { SVTextInput } from '../../core';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { MESSAGES } from '@/constants/messages';
import { Typography, Stack } from '@mui/material';

export default function DocumentLinkControls() {
  const { LABEL } = PROGRAM_SETTINGS.DOCUMENT_LINKS_INDEX_FACT_SHEET;
  const { invalidFormatLink } = MESSAGES;
  return (
    <Stack spacing={3}>
      <Typography component="p">
        Google Drive link for the latest Index Fact Sheet
      </Typography>
      <SVTextInput
        name="indexFactSheetLink"
        label={LABEL}
        rules={{
          required: true,
          validate: value => {
            if (!REGEX.CHECK_URL.test(value)) {
              return invalidFormatLink;
            }

            return;
          },
        }}
      />
    </Stack>
  );
}
